// import React from 'react';
// import {useTranslation} from 'react-i18next';

const FooterMain = () => {
  // const [t] = useTranslation();
  // return <footer className="main-footer"></footer>;
  return null;
};

export default FooterMain;
